import { render, staticRenderFns } from "./map-restos.vue?vue&type=template&id=2622417c"
import script from "./map-restos.vue?vue&type=script&lang=ts"
export * from "./map-restos.vue?vue&type=script&lang=ts"
import style0 from "./map-restos.vue?vue&type=style&index=0&id=2622417c&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2622417c')) {
      api.createRecord('2622417c', component.options)
    } else {
      api.reload('2622417c', component.options)
    }
    module.hot.accept("./map-restos.vue?vue&type=template&id=2622417c", function () {
      api.rerender('2622417c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "eatself-directory/map-restos.vue"
export default component.exports